import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "fileType-pdf",
  "use": "fileType-pdf-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"fileType-pdf\"><defs><symbol id=\"fileType-pdf_a\" data-name=\"file-pdf\" viewBox=\"0 0 20 20\"><path d=\"M15.77 0H0v20h20V4.23zM5 10.89H3.43v2.34h-.92v-6H5c1.43 0 2.15.61 2.15 1.83S6.43 10.89 5 10.89zm7.18 1.53a2.87 2.87 0 0 1-2.21.81H7.79v-6H10a2.85 2.85 0 0 1 2.19.77 3.1 3.1 0 0 1 .71 2.19 3.13 3.13 0 0 1-.73 2.23zM17.7 8h-3.16v1.75h3v.78h-3v2.69h-.92v-6h4.08zm-1.93-3.63V.28l4.08 4.08zM4.93 8h-1.5v2.1h1.5a1.58 1.58 0 0 0 1-.25 1 1 0 0 0 .3-.85.92.92 0 0 0-.32-.79A1.57 1.57 0 0 0 4.93 8zm4.88 0h-1.1v4.45H9.8a2.27 2.27 0 0 0 1.68-.55 2.35 2.35 0 0 0 .52-1.68 2.37 2.37 0 0 0-.51-1.68A2.24 2.24 0 0 0 9.81 8z\" fill=\"#ef5a3c\" /></symbol></defs><title>pdf</title><g data-name=\"图层 2\"><use width=\"20\" height=\"20\" xlink:href=\"#fileType-pdf_a\" data-name=\"图层 1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/fileType-pdf.svg
// module id = 28+Z
// module chunks = 6